import * as Constants from "../../utils/constants";
export const buyLoadRequest = (payload: any) => ({
  type: Constants.BUYLOAD_DATA_REQUEST,
  payload,
});

export const buyLoadResponse = (payload: any) => ({
  type: Constants.BUYLOAD_DATA_SUCCESS,
  payload,
});

export const buyLoadShipmentRequest = (payload: any, callback?: Function) => ({
  type: Constants.BUYLOAD_SHIPMENT_REQUEST,
  payload: {
    data: payload,
    callback
  },
});
export const buyLoadShipmentResponse = (payload: any) => ({
    type: Constants.BUYLOAD_SHIPMENT_SUCCESS,
    payload,
  });
  export const buyLoadStatusRemove=() =>({
    type:Constants.BUYLOAD_REMOVE_STATUS,
    
  })
  export const successclearBuyLoadResponse =(payload:any) =>({
    type:Constants.CLEARBUYLOAD_RESPONSE,
    payload
  })
  export const isGetShipmentError=(payload:any)=>({
    type:Constants.isGetshipmentError,payload
  })
